import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          fullName: formData.fullName,
          companyName: formData.companyName,
          phone: formData.phone,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      );

      alert("Message sent successfully!");

      setFormData({
        fullName: "",
        companyName: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
  console.error("FULL ERROR:", error);
  // console.log("SERVICE:", process.env.REACT_APP_EMAILJS_SERVICE_ID);
  // console.log("TEMPLATE:", process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
  // console.log("PUBLIC:", process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  console.error("TEXT:", error?.text);
  console.error("MESSAGE:", error?.message);
} finally {
      setLoading(false);
    }
  };

  return (
    <div className="container contact-us">
      <div className="form">
        <div className="form_heading">
          <h2>Send Us A Message</h2>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="companyName"
              placeholder="Company Name"
              value={formData.companyName}
              onChange={handleChange}
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              pattern="[0-9+\-\s]{8,20}"
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>

      <div className="contact_content">
        <div className="contact-text">
          <h1>Contact Details</h1>

          <div className="wp_contact_text">
            <p className="address">
              Address: Office Number 212, Ibn Battuta Gate Office Building,
              Jebel Ali Village, Dubai
            </p>

            <p className="working_hours">
              Working Hours: Sunday – Thursday: 8:00 AM – 6:00 PM
            </p>

            <p className="phone">
              Phone Number:
              <a href="tel:+97142896057"> +971 4 289 6057</a>
            </p>

            <p className="fax">
              Fax:
              <a href="tel:+97142896056"> +971 4 289 6056</a>
            </p>

            <p className="mail">
              Email:
              <a
                href="mailto:admin@gemcomep.com"
                className="mail_id"
              >
                {" "}
                admin@gemcomep.com
              </a>
            </p>
          </div>
        </div>

        <div className="contact-map">
          <iframe
            title="Gemco MEP Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.7797137392167!2d55.111333187711914!3d25.04154878078945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f133d5ef73895%3A0x15416b3e1fd11b9c!2sIbn%20Battuta%20Gate%20-%20Jebel%20Ali%20Village%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1765292226953!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;